export default "/images/search.svg?ced13e311b4171b351b230ba1da7498e";